module.exports = __webpack_public_path__ + "media/images/850/REM_sleep_night_stars-d3e968d383f5ffdedf5aba9bbadbf68a.jpg";